"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactDiv100vh = _interopRequireDefault(require("react-div-100vh"));

var _slice = require("@lce/slice");

var _router = require("@reach/router");

var _Logo = _interopRequireDefault(require("./Logo"));

var Styled = _interopRequireWildcard(require("./SiteDown.style"));

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj["default"] = obj;
    return newObj;
  }
}

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var SiteDown = function SiteDown() {
  var handleRefresh = function handleRefresh() {
    (0, _router.navigate)('https://www.littlecaesars.com');
  };

  return _react["default"].createElement(_reactDiv100vh["default"], null, _react["default"].createElement(_slice.Flex, {
    style: {
      height: '100%'
    },
    flexDirection: "column"
  }, _react["default"].createElement(_slice.Box, {
    bg: "white"
  }, _react["default"].createElement(Styled.Header, null, _react["default"].createElement(_Logo["default"], null))), _react["default"].createElement(Styled.SiteDown, {
    justifyContent: ['center', 'flex-start'],
    flexDirection: "column",
    alignItems: "center",
    backgroundColor: "orange",
    flex: "1 0 auto"
  }, _react["default"].createElement(_slice.Box, {
    pt: [5, 152],
    px: 5,
    pb: 5
  }, _react["default"].createElement(_slice.Headline, {
    fontSize: [14, 22],
    color: "white",
    mb: 0
  }, "Sorry, We\u2019re Offline."), _react["default"].createElement(Styled.Box, {
    my: [5, 8]
  }, _react["default"].createElement(Styled.Text, null, "Something went wrong. Rest assured we are working on it."), _react["default"].createElement(Styled.Text, null, "Check back with us later or refresh your browser.")), _react["default"].createElement(Styled.MobileBox, {
    my: [5, 8]
  }, _react["default"].createElement(Styled.Text, null, "Something went wrong. Rest assured we are working on it. Check back with us later or refresh your browser.")), _react["default"].createElement(Styled.Button, {
    fontSize: 6,
    bg: "orange",
    color: "black",
    "data-testid": "Route",
    borderColor: "black",
    px: 8,
    onClick: handleRefresh
  }, "REFRESH NOW"))), _react["default"].createElement(_slice.Box, {
    px: [5, 8],
    py: [5]
  }, _react["default"].createElement(_slice.Text, {
    fontSize: "14px",
    textAlign: "center",
    width: [1, 2 / 3],
    margin: "0 auto"
  }, "\xA92003-2020 Little Caesar Enterprises, Inc. All rights reserved. The Little Caesars\xAE Pizza name, logos and related marks are trademarks licensed to Little Caesar Enterprises, Inc."))));
};

var _default = SiteDown;
exports["default"] = _default;